import { render, staticRenderFns } from "./PremiumLoadingCreate.vue?vue&type=template&id=129e25d8"
import script from "./PremiumLoadingCreate.vue?vue&type=script&lang=js"
export * from "./PremiumLoadingCreate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports